export default "__VITE_ASSET__fXungaW5__"